module.exports = __webpack_public_path__ + "media/images/athletes/1587-ba77310a981fd0ac03dd6a972aa3f966.png";